// 9fbef606107a605d69c0edbcd8029e5d

export const getChatSummary = (state) => state?.AIAssistant?.chatSummary || [];

export const getLoadingState = (state) => state?.AIAssistant?.isLoading || false;
